/**
* Person Module
* person (PAX, Provider, Contact, ...) services and components
**/

//Core
import { NgModule, ModuleWithProviders }       from '@angular/core';
import { CommonModule }       from '@angular/common';

//
import { GenericModule } from './generic.module';
import { UIModule } from '../ui/ui.module';

//Service
import { DatePipeModule } from '../date/date.module';
import { TravellerComponentModule } from '../component/traveller/travellerComponent.module';
import { TravellerModule } from 'libraries/service/traveller/traveller.module';

@NgModule({
    imports: [
        CommonModule,
        GenericModule,
        UIModule,
        DatePipeModule,
        TravellerComponentModule,
        TravellerModule,
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class PersonModule { }
